<template>
  <div class="flex flex-col items-start text-white m-4">
    <div class="flex flex-row gap-2 items-center my-2">
      <button class="rounded-full bg-paleta-3" @click="volver">
        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-left" class="h-8 w-8 p-1" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
          <path
            fill="currentColor"
            d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"
          ></path>
        </svg>
      </button>
      <div class="text-white text-xl">Historial</div>
    </div>
    <div v-for="(movimiento, key) in ultimosMovimientos" v-bind:key="key" class="flex flex-row p-2 bg-teal-500 rounded-md my-1 w-full shadow-xl">
      <div class="text-left flex-grow">
        <div>{{ format(parseISO(movimiento.fechaHora), "dd/MM/yyyy") }}</div>
        <div>{{ format(parseISO(movimiento.fechaHora), "hh:mm") }}</div>
      </div>
      <div class="text-right flex-grow">
        <div class="text-xl font-bold">{{ currency(movimiento.importe, { decimal: ",", symbol: "" }).format() }}</div>
        <div class="text-sm">{{ movimiento.descripcion }}</div>
      </div>
      <div @click="click(movimiento.tipo, movimiento.id)" class="self-center px-3 w-12">
        <div v-show="movimiento.tipo == 'BOLETO'">
          <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-right" class="h-8 w-8" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
            <path
              fill="currentColor"
              d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"
            ></path>
          </svg>
        </div>
      </div>
    </div>
    <button @click="ver3DiasMas()">Ver 3 días más</button>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { parseISO, format } from "date-fns";
import currency from "currency.js";

export default {
  data() {
    return {
      dias: 1,
      parseISO,
      format,
      currency
    };
  },
  created() {
    this.$store.dispatch("obtenerUltimosMovimientos", { dias: this.dias });
  },
  methods: {
    volver() {
      this.$router.go(-1);
    },
    click(tipo, id) {
      if (tipo === "BOLETO") {
        this.$store.dispatch("cargarApuestaSeleccionadaHistorial", { id });
      }
    },
    ver3DiasMas() {
      this.dias += 3;
      this.$store.dispatch("obtenerUltimosMovimientos", { dias: this.dias });
    }
  },
  computed: {
    ...mapState({
      ultimosMovimientos: state => state.historial.ultimosMovimientos
    })
  }
};
</script>
